import { Button, Dropdown } from '@cobliteam/ui/components';

import type { TrackingDevice } from '@cobliteam/api-lib';

import { useUser } from '@cobliteam/hooks';

import Icon from '@cobliteam/ui/icons';

import { EventToggle } from '../EventToggle/EventToggle';

export interface MapControlDropdownProps {
  showGeofences: boolean;
  showMediaEvents: Boolean | undefined;
  showRoadSpeedEvents: boolean;
  showVehicleSpeedEvents: boolean;
  showGeofencesEvents: boolean;
  selectedDevice: TrackingDevice | undefined;
  useMapMatch: boolean;
  setShowRoadSpeedEvents: () => {};
  setShowVehicleSpeedEvents: () => {};
  setShowGeofencesEvents: () => {};
  handleToggleGeofences: () => {};
  setMediaEvents: () => {};
  setUseMapMatch: () => {};
}

const MapControlDropdown = ({
  showGeofences,
  showMediaEvents,
  showRoadSpeedEvents,
  showVehicleSpeedEvents,
  showGeofencesEvents,
  selectedDevice,
  useMapMatch,
  setShowRoadSpeedEvents,
  setShowVehicleSpeedEvents,
  handleToggleGeofences,
  setShowGeofencesEvents,
  setMediaEvents,
  setUseMapMatch,
}: MapControlDropdownProps) => {
  const { useGetUserData } = useUser();
  const { data: userData } = useGetUserData();
  const fleetHasCamera = userData?.hasCameraFlag;

  return (
    <Dropdown
      overlay={
        <Dropdown.Overlay className='w-fit'>
          <Dropdown.Body className='my-0 px-2.5 py-0'>
            <EventToggle
              geofencesActive={showGeofences}
              roadSpeedEventActive={showRoadSpeedEvents}
              vehicleSpeedEventActive={showVehicleSpeedEvents}
              mediaEventsActive={Boolean(showMediaEvents)}
              geofencesEventsActive={showGeofencesEvents}
              onToggleRoadSpeedEvents={setShowRoadSpeedEvents}
              onToggleVehicleSpeedEvents={setShowVehicleSpeedEvents}
              onToggleGeofences={handleToggleGeofences}
              onToggleMediaEvents={setMediaEvents}
              onToggleGeofencesEvents={setShowGeofencesEvents}
              selectedDevice={selectedDevice}
              fleetHasCamera={Boolean(fleetHasCamera)}
              mapMatchActive={useMapMatch}
              onToggleMapMatch={setUseMapMatch}
            />
          </Dropdown.Body>
        </Dropdown.Overlay>
      }
    >
      <Button variant='outlined' startIcon={<Icon name='layers' />} className='bg-white shadow hover:bg-gray-4'>
        Opções
      </Button>
    </Dropdown>
  );
};

export default MapControlDropdown;
